import { render, staticRenderFns } from "./WorkflowSessions.vue?vue&type=template&id=2fe9f550&scoped=true"
import script from "./WorkflowSessions.vue?vue&type=script&lang=js"
export * from "./WorkflowSessions.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSessions.vue?vue&type=style&index=0&id=2fe9f550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9f550",
  null
  
)

export default component.exports